import { httpService } from './http.service';
import { API_ENDPOINTS } from '../config/api.config';

class ResponseService {
  /**
   * Récupérer les réponses d'une demande
   * @param {number} demandeId - ID de la demande
   * @returns {Promise<Array>} - Liste des réponses
   */
  async getResponses(demandeId) {
    try {
      const response = await httpService.get(API_ENDPOINTS.RESPONSES.LIST_BY_DEMANDE(demandeId));
      console.log('Réponses récupérées:', response);
      return Array.isArray(response.results) ? response.results : Array.isArray(response) ? response : [];
    } catch (error) {
      console.error(`Erreur lors de la récupération des réponses pour la demande ${demandeId}:`, error);
      return [];
    }
  }

  /**
   * Récupérer une réponse spécifique
   * @param {number} responseId - ID de la réponse
   * @returns {Promise<Object>} - Détails de la réponse
   */
  async getResponseDetails(responseId) {
    try {
      const response = await httpService.get(API_ENDPOINTS.RESPONSES.DETAIL(responseId));
      console.log('Détails de la réponse récupérés:', response);
      return response;
    } catch (error) {
      console.error(`Erreur lors de la récupération de la réponse ${responseId}:`, error);
      throw error;
    }
  }

  /**
   * Créer une nouvelle réponse
   * @param {Object} responseData - Données de la réponse
   * @returns {Promise<Object>} - Réponse créée
   */
  async createResponse(responseData) {
    try {
      const response = await httpService.post(API_ENDPOINTS.RESPONSES.CREATE, responseData);
      console.log('Réponse créée:', response);
      return response;
    } catch (error) {
      console.error('Erreur lors de la création de la réponse:', error);
      throw error;
    }
  }

  /**
   * Mettre à jour une réponse
   * @param {number} responseId - ID de la réponse
   * @param {Object} responseData - Nouvelles données de la réponse
   * @returns {Promise<Object>} - Réponse mise à jour
   */
  async updateResponse(responseId, responseData) { 
    try {
      const response = await httpService.put(API_ENDPOINTS.RESPONSES.UPDATE(responseId), responseData);
      console.log('Réponse mise à jour:', response);
      return response;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la réponse ${responseId}:`, error);
      throw error;
    }
  }

  /**
   * Supprimer une réponse
   * @param {number} responseId - ID de la réponse
   * @returns {Promise<Object>} - Confirmation de suppression
   */
  async deleteResponse(responseId) {
    try {
      const response = await httpService.delete(API_ENDPOINTS.RESPONSES.DELETE(responseId));
      console.log('Réponse supprimée:', response);
      return response;
    } catch (error) {
      console.error(`Erreur lors de la suppression de la réponse ${responseId}:`, error);
      throw error;
    }
  }
}

export const responseService = new ResponseService();
export default responseService;